<template>
  <v-layout 
    pt-5
    mt-4
    fluid
    >
    <v-flex>
      <v-card
      >  
        <v-toolbar 
          :color="strongColor" 
          flat 
          dark>
            <v-btn   
              :color="strongColor"
              :key="groupId"
              :to="{
                  name: 'group',
                  params: {
                    groupId: groupId
                  }
                }"
              dark
              icon
              >
            <v-icon>close</v-icon>
            </v-btn>
              <v-toolbar-title>Edit Group Members for {{ groupName }}</v-toolbar-title>     
        </v-toolbar>
        <v-container 
          align-content-start>
          <v-layout row>
           
            <v-flex 
              xs12 
              md4
              ma-1
              >
              <edit-clients-list
                :key="groupId"
                :group-id="groupId"/>
            </v-flex>


            <v-spacer/>
            <v-layout 
              column
              fluid
              >
              <v-flex 
                xs12  
                justify-start
                ma-1
                >
                <clients-group-search-panel
                />
              </v-flex>
              <v-flex 
                xs12
                ma-1 
                >
                <clients-group-panel
                  :key="groupId"
                  :group-id="groupId"/>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>
      </v-card>
      </v-flex>
      </v-layout>
  
</template>

<script>
import { mapState } from "vuex";
import ClientsGroupPanel from "./EditClientsGroupPanel";
import ClientsGroupSearchPanel from "./EditClientsGroupSearchPanel";
import EditClientsList from "./EditClientsList";
import { fixName, STRONG_COLOR } from "@/components/globals/consts";
import EventBus from "@/main";
import GroupsService from '@/services/GroupsService'

export default {
  components: {
    ClientsGroupSearchPanel,
    ClientsGroupPanel,
    EditClientsList
  },
  data() {
    return {
      deleteDialog: false,
      strongColor: STRONG_COLOR
    };
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user", "route", "currentGroupClients", "renderClientList", "groupId", "groupName"])
  },
  async created() {
     
    if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}

    let groupId = Number(this.route.params.groupId)
    await this.$store.dispatch('setGroupId', groupId)
    let group = (await GroupsService.show(this.groupId)).data
    await this.$store.dispatch('setGroupName', group.name)
  },
  async mounted() {

   await this.$store.dispatch('setRenderClientList', true)

  }, 
  async destroy() {
   await this.$store.dispatch("setCurrentGroupClients", []);
   await this.$store.dispatch('setRenderClientList', false)
   await this.$store.dispatch('setGroupId', null)
   await this.$store.dispatch('setGroupName', null)
   await this.$store.dispatch('setSearchResults', null)
   await this.$store.dispatch('setClientsToRemoveFromGroup', {})

    console.log('destroy in index')
  }  
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditClientsInGroup/EditClientsInGroupIndex.vue